import { formatAppDate } from "../../app/utils/appTimeFormat";

export function formatPeriodLabel(periodKey) {
  if (!periodKey) return "Unknown week";
  const [y, m, d] = periodKey.split("-").map(Number);
  if (!y || !m || !d) return periodKey;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return formatAppDate(dt);
}

export function formatPrizeAmount(value) {
  const n = Number(value) || 0;
  if (n >= 1000) return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k`;
  return String(Math.round(n));
}

export function weekTotals(snapshot = {}) {
  return {
    cash: snapshot.totalCashPaid ?? 0,
    coin: snapshot.totalCoinPaid ?? 0,
    winners: snapshot.totalWinners ?? snapshot.winners?.length ?? 0,
  };
}

export function topWinners(snapshot = {}, count = 3) {
  return (snapshot.winners || []).slice().sort((a, b) => a.rank - b.rank).slice(0, count);
}
